<div class="d-flex">
	<div class="m-2">
		<span class="p-float-label">
			<p-calendar #startDatePicker (onSelect)="dateSelect()" [(ngModel)]="startDate"></p-calendar>
			<label for="startDatePicker">Start Date</label>
		</span>
	</div>
	<div class="m-2">
		<span class="p-float-label">
			<p-calendar #endDatePicker (onSelect)="dateSelect()" [(ngModel)]="endDate"></p-calendar>
			<label for="endDatePicker">End Date</label>
		</span>
	</div>
</div>

<p-table [value]="itemsByDayModel" [loading]="loading">
	<ng-template pTemplate="header">
		<tr>
			<th style="width: 5%"></th>
			<th>Pick up date</th>
			<th>Queued Items</th>
			<th>Anticipated Revenue</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-rec #body>
		<tr>
			<td style="width: 5%" (click)="rec.expanded = !rec.expanded">
				<fa-icon *ngIf="!rec.expanded" [icon]="['far', 'angle-right']" size="2x"></fa-icon>
				<fa-icon *ngIf="rec.expanded" [icon]="['far', 'angle-down']" size="2x"></fa-icon>
			</td>
			<td>{{ rec.queueDate }}</td>
			<td>{{ rec.totalCount }}</td>
			<td>{{ rec.totalRevenue | currency }}</td>
		</tr>
		<tr *ngIf="rec.expanded">
			<td colspan="4">
				<p-table [value]="rec.items">
					<ng-template pTemplate="header">
						<tr>
							<th style="width: 5%"></th>
							<th>Item</th>
							<th>Quantity Expected</th>
							<th>Due Times</th>
							<th></th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-itm>
						<tr>
							<td style="width: 5%"></td>
							<td>{{ itm.name }}</td>
							<td>{{ itm.quantity }}</td>
							<td>
								<div *ngFor="let time of itm.dueTimes">
									{{ time }}
								</div>
							</td>
							<td>
								<div *ngFor="let check of itm.itemChecks" (click)="checkSelected = check">
									{{ app.references.toTitleCase(check.lastName) }} -- DUE: {{ moment(check.dueDateTime).format("LT") }}
								</div>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="3"><i>No future orders found for the specified date range</i></td>
		</tr>
	</ng-template>
</p-table>

<p-sidebar [(visible)]="checkSelected" position="right" appendTo="body" (onHide)="checkSelected = undefined" [showCloseIcon]="false" styleClass="p-sidebar-md">
	<app-check-record-viewer *ngIf="checkSelected" [incomingCheck]="checkSelected"></app-check-record-viewer>
</p-sidebar>
